import { useDeviceType } from '@cian/ui-kit';

export function useStandardButtonSize() {
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone' || deviceType === 'tablet';

  return isMobile ? 'M' : 'L';
}
